import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, FormHelperText, TextField, FormControl, FormControlLabel, InputLabel, Input, } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import WarningIcon from '@/assets/images/warning.svg';
import clsx from 'clsx';
const useStyles = makeStyles((theme) => ({
  root: {},
  dateComponent: {
    width: '100%',
    '& .MuiInputLabel-formControl': {
      color: '#575d65',
      fontSize: '16px',
      lineHeight: '24px',
      transform: 'translate(8px, 16px)',
      zIndex: 1,
      '&.MuiInputLabel-shrink': {
        color: '#575D65',
        fontSize: '12px',
        lineHeight: '16px',
        transform: 'translate(8px, 8px)',
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
      display: 'none',
    },
    '& .MuiInputBase-input': {
      color: '#575d65',
      height: '24px',
      padding: '24px 8px 8px 8px',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
    },
    '&.focused': {
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: 0,
        height: '2px',
        width: '100%',
        backgroundColor: `${theme.palette.$uploadBorderHover}`,
      },
    },
  },
  helperTextComponent: {
    fontSize: '12px',
    lineHeight: '16px',
    marginLeft: '8px',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'start',
  },
  inputsContainer: {
    display: 'flex',
    height: '56px',
    background: '#F7F8F9',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      height: '1px',
      width: '100%',
      backgroundColor: `${theme.palette.$lineGrey}`,
    },
    '&:hover::after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: 0,
      height: '2px',
      width: '100%',
      backgroundColor: `${theme.palette.$lineGrey}`,
    },
  },
  dateLabel: {

  },
  dayInput: {
    width: '9%',
    '& input': {
      paddingRight: '0 !important',
    },
  },
  monthInput: {
    width: '11%',
    '& input': {
      paddingLeft: '6px !important',
      paddingRight: '0 !important',
    },
  },
  yearInput: {
    width: '83%',
    '& input': {
      paddingLeft: '6px !important',
    },
  },
  splitChar: {
    color: theme.palette.$lineGrey,
    height: '24px',
    paddingTop: '24px',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
  },
  spiltCharFirst: {
    paddingLeft: '4px',
    paddingRight: 0,
  },
  spiltCharSecond: {
    paddingLeft: '4px',
    paddingRight: '6px',
  },
  helperTextComponent: {
    fontSize: '12px',
    lineHeight: '16px',
    marginLeft: '8px',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'start',
  },
  errorMessage: {
    marginTop: '10px',
    height: theme.palette.$lhH2,
    color: theme.palette.$errorRed,
    fontSize: theme.typography.$fzDes,
    lineHeight: theme.typography.$lhDes,
    '& p': {
      margin: 0,
    },
  },
  iconWarning: {
    verticalAlign: 'middle',
    marginRight: '4px',
  },
}));

const DateComponentCustom = ({
  format, onChange, value, message, invalidDateMessage, errored, errorMessage, verifyDate,
}) => {
  const classes = useStyles();
  const dayInput = useRef(null);
  const monthInput = useRef(null);
  const yearInput = useRef(null);
  const [dayPlaceHolder, setDayPlaceHolder] = useState('');
  const [monthPlaceHolder, setMonthPlaceHolder] = useState('');
  const [yearPlaceHolder, setYearPlaceHolder] = useState('');
  const [focused, setFocused] = useState(false);
  const [showSplitChar, setShowSplitChar] = useState(false);
  const [shrinked, setShrinked] = useState(false);

  const [dayValue, setDayValue] = useState('');
  const [monthValue, setMonthValue] = useState('');
  const [yearValue, setYearValue] = useState('');

  const dateContainerRef = useRef(null);

  const setPlaceHolders = () => {
    setDayPlaceHolder('dd');
    setMonthPlaceHolder('mm');
    setYearPlaceHolder('yyyy');
  };
  const setPlaceHoldersEmpty = () => {
    setDayPlaceHolder('');
    setMonthPlaceHolder('');
    setYearPlaceHolder('');
  };
  const dayInputFocus = () => {
    setPlaceHolders();
    setFocused(true);
  };
  const monthInputFocus = () => {
    setPlaceHolders();
    if (!focused) {
      const dayInputDom = dayInput.current;
      dayInputDom.focus();
    }
  };
  const yearInputFocus = () => {
    setPlaceHolders();
    if (!focused) {
      const dayInputDom = dayInput.current;
      dayInputDom.focus();
    }
  };

  const dayChange = (event) => {
    const { value: day } = event.target;
    if (/^\d*$/.test(day)) {
      setDayValue(day);
      const dayInputDom = dayInput.current;
      const position = dayInputDom.selectionStart;
      if (position === 2) {
        setTimeout(() => {
          const monthInputDom = monthInput.current;
          monthInputDom.focus();
          monthInputDom.setSelectionRange(0, 0);
        }, 0);
      }
    }
  };

  const monthChange = (event) => {
    const { value: month } = event.target;
    if (/^\d*$/.test(month)) {
      setMonthValue(month);
      const monthInputDom = monthInput.current;
      const position = monthInputDom.selectionStart;
      if (position === 0) {
        setTimeout(() => {
          const dayInputDom = dayInput.current;
          dayInputDom.focus();
          dayInputDom.setSelectionRange(2, 2);
        }, 0);
      }
      if (position === 2) {
        setTimeout(() => {
          const yearInputDom = yearInput.current;
          yearInputDom.focus();
          yearInputDom.setSelectionRange(0, 0);
        }, 0);
      }
    }
  };
  const yearChange = (event) => {
    const { value: year } = event.target;
    if (/^\d*$/.test(year)) {
      setYearValue(year);
      const yearInputDom = yearInput.current;
      const position = yearInputDom.selectionStart;
      if (position === 0) {
        setTimeout(() => {
          const monthInputDom = monthInput.current;
          monthInputDom.focus();
          monthInputDom.setSelectionRange(2, 2);
        }, 0);
      }
    }
  };

  const handleClickOutside = (event) => {
    const domNode = dateContainerRef.current;
    if (domNode && !domNode.contains(event.target)) {
      const dayInputDom = dayInput.current;
      const monthInputDom = monthInput.current;
      const yearInputDom = yearInput.current;
      const fullStr = `${dayInputDom.value}${monthInputDom.value}${yearInputDom.value}`;
      if (fullStr.length === 8 || fullStr.length === 0) {
        if (fullStr.length === 0) {
          setShowSplitChar(false);
          setShrinked(false);
          verifyDate('');
        }
        setFocused(false);
        if (fullStr.length === 8) {
          const date = `${yearInputDom.value}-${monthInputDom.value}-${dayInputDom.value}`;
          verifyDate(date);
        }
      } else {
        setFocused(true);
      }
    }
  };

  const inputBlur = (event, name) => {
    const { value: dateValue } = event.target;
    onChange(name, dateValue);
  };

  useEffect(() => {
    if (focused) {
      setPlaceHolders();
      setShowSplitChar(true);
      setShrinked(true);
    } else {
      setPlaceHoldersEmpty();
    }
  }, [focused]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div>
      <FormControl className={clsx(classes.dateComponent, focused ? 'focused' : '')} ref={dateContainerRef}>
        {/* MuiInputLabel-shrink */}
        <InputLabel htmlFor="my-input" className={clsx(classes.dateLabel, shrinked ? 'MuiInputLabel-shrink' : '')}>Date of birth</InputLabel>
        <div className={classes.inputsContainer}>
          <Input
            id="my-input"
            aria-describedby="my-helper-text"
            placeholder={dayPlaceHolder}
            className={classes.dayInput}
            onFocus={() => dayInputFocus()}
            onChange={(event) => dayChange(event)}
            onBlur={(event) => inputBlur(event, 'date')}
            inputProps={{
              maxLength: 2,
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
            inputRef={dayInput}
            value={dayValue}
          />
          {showSplitChar && <span className={clsx(classes.splitChar, classes.spiltCharFirst)}>/</span>}
          <Input
            aria-describedby="my-helper-text"
            placeholder={monthPlaceHolder}
            className={classes.monthInput}
            onFocus={() => monthInputFocus()}
            onChange={(event) => monthChange(event)}
            onBlur={(event) => inputBlur(event, 'month')}
            inputProps={{
              maxLength: 2,
              pattern: '[0-9]*',
            }}
            inputRef={monthInput}
            value={monthValue}
          />
          {showSplitChar && <span className={clsx(classes.splitChar, classes.spiltCharSecond)}>/</span>}
          <Input
            aria-describedby="my-helper-text"
            placeholder={yearPlaceHolder}
            className={classes.yearInput}
            onFocus={() => yearInputFocus()}
            onChange={(event) => yearChange(event)}
            onBlur={(event) => inputBlur(event, 'year')}
            inputProps={{
              maxLength: 4,
              pattern: '[0-9]*',
            }}
            inputRef={yearInput}
            value={yearValue}
          />
        </div>
      </FormControl>
      {errored && (
        <div className={classes.errorMessage}>
          <img src={WarningIcon} className={classes.iconWarning} alt="#" />
          <span>{errorMessage}</span>
        </div>
      )}
      <FormHelperText id="my-helper-text" className={classes.helperTextComponent}>Date, month, year</FormHelperText>
    </div>
  );
};

DateComponentCustom.defaultProps = {
  format: 'dd/MM/yyyy',
  onChange: (_) => _,
  value: '',
  message: '',
  invalidDateMessage: '',
  errored: false,
  errorMessage: '',
  verifyDate: (_) => _,
};

DateComponentCustom.propTypes = {
  format: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  message: PropTypes.string,
  invalidDateMessage: PropTypes.string,
  errored: PropTypes.bool,
  errorMessage: PropTypes.string,
  verifyDate: PropTypes.func,
};

export default DateComponentCustom;
